export enum Country {
    DE = 'de',
    FR = 'fr',
    NL = 'nl',
    BENL = 'benl',
    BEFR = 'befr',
    AT = 'at',
    CHDE = 'chde',
    CHFR = 'chfr',
    UK = 'uk',
    IT = 'it',
    PL = 'pl',
    FI = 'fi',
    SE = 'se',
    DK = 'dk',
    ES = 'es',
    CS = 'cs',
}

export enum Appdomain {
    DE = 17,
    FR = 18,
    NL = 35,
    BENL = 36,
    BEFR = 37,
    COM = 38,
    AT = 39,
    CHDE = 40,
    CHFR = 41,
    UK = 43,
    IT = 44,
    PL = 45,
    ES = 46,
    CS = 51,
}
